<template>
    <div>
        <v-form name="manageDetailsForm" ref="manageDetailsForm">
            <div class="tw-flex tw-flex-row tw-gap-6 tw-p-1">
                <div class="tw-flex tw-flex-col tw-w-1/3 tw-gap-2 section"><!-- left side -->
                    <v-text-field
                        v-show="isEdit"
                        v-model="production.id"
                        label="Production ID"
                        hide-details="auto"
                        readonly
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-show="isEdit"
                        v-model="production.remit_id"
                        :error-messages="errors?.remit_id"
                        label="Remit ID"
                        hide-details="auto"
                        dense
                    ></v-text-field>
                    <v-text-field
                        v-model="production.name"
                        label="Name"
                        :error-messages="errors?.name"
                        :rules="[rules.required]"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-model="production.alternate_name"
                        label="Alternate Name"
                        :error-messages="errors?.alternate_name"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <div class="tw-flex tw-gap-2">
                        <date-picker
                            v-model="production.date_start"
                            :error-messages="errors?.date_start"
                            display-label="Start Date"
                            dense
                            hide-details="auto"
                            reactive
                            ref="datePicker"
                        />
                        <date-picker
                            v-model="production.date_wrap"
                            :error-messages="errors?.date_wrap"
                            display-label="Wrap Date"
                            dense
                            hide-details="auto"
                            reactive
                            ref="datePicker"
                        />
                    </div>
                    <div class="tw-flex tw-gap-2">
                        <date-picker
                            v-model="production.date_prep"
                            :error-messages="errors?.date_prep"
                            display-label="Prep Date"
                            dense
                            hide-details="auto"
                            reactive
                            ref="datePicker"
                        />
                        <date-picker
                            v-model="production.date_post"
                            :error-messages="errors?.date_post"
                            display-label="Post Date"
                            dense
                            hide-details="auto"
                            reactive
                            ref="datePicker"
                        />
                    </div>
                    <v-text-field
                        v-model="production.location"
                        label="Location"
                        :error-messages="errors?.location"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>

                </div>

                <div class="tw-flex tw-flex-col tw-w-1/3 tw-gap-2 section"><!-- middle -->
                    <v-select
                        v-model="production.print_color"
                        :items="getPrintColors"
                        label="Print Color"
                        :error-messages="errors?.print_color"
                        hide-details="auto"
                        dense
                        reactive
                        clearable
                    ></v-select>
                    <v-text-field
                        v-model="production.genre"
                        label="Genre"
                        :error-messages="errors?.genre"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-model="production.company"
                        label="Parent Company"
                        :error-messages="errors?.company"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-autocomplete
                        v-model="production.contract_id"
                        :items="valuelist.CONTRACTS"
                        label="Contract Type"
                        hide-details="auto"
                        dense
                        outlined
                        clearable
                    ></v-autocomplete>
                    <v-text-field
                        v-model="production.labour_relations"
                        label="Labour Relations"
                        :error-messages="errors?.labour_relations"
                        hide-details="auto"
                        dense
                        clearable
                    ></v-text-field>
                    <v-select
                        v-model="production.status"
                        :items="getProdStatus"
                        label="Status"
                        hide-details="auto"
                        dense
                        reactive
                        clearable
                    ></v-select>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-2 tw-w-1/3 section"><!-- right side -->
                    <v-checkbox
                        v-model="production.disability_deducted"
                        label="Disability Deducted"
                        :error-messages="errors?.disability_deducted"
                        hide-details="auto"
                        dense
                    ></v-checkbox>
                    <v-checkbox
                        v-model="production.include_report"
                        label="Production Report"
                        :error-messages="errors?.include_report"
                        hide-details="auto"
                        dense
                    ></v-checkbox>
                </div>
            </div>
            <div class="tw-p-1" v-show="isUserAdmin">
                <v-btn v-show="isEdit" @click="archiveProduction" :loading="archiveLoading" class="main-btn">Delete Production</v-btn>
            </div>
        </v-form>


    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import DatePicker from "@/Generic/DatePicker";

    export default {
        name: "ProductionsManageDetails",
        components: {
            SmartTable,
            InternalHeader,
            DatePicker,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                production: this.input || {},
                constant: this.constants,
                valuelist: this.valuelists,
                saveLoading: false,
                archiveLoading: false,
                isEdit: this.isEditProp,
                rules: {
                    required: value => !!value || 'Required',
                },
                errors: null,
            }
        },
        computed: {
            isUserAdmin() {
                if (this.$page.user.role === 'ADMIN') {
                    return true
                } else {
                    return false
                }
            },
            getPrintColors() {
                return Object.values(this.constant.PRINT_COLORS)
            },
            getProdStatus() {
                return Object.values(this.constant.PRODUCTION_STATUS)
            },
        },
        methods: {
            findValuelist(list, id) {
                if (list && id) {
                    return list.find(obj => obj.value === id)
                } else {
                    return ""
                }
            },
            saveDetails() {
                if (this.$refs.manageDetailsForm.validate()) {
                    let formData = this.production

                    var url = ''
                    var method = ''

                    if(this.isEdit) {
                        url = route('productions.update', this.production.id)
                        method = 'put'
                    } else {
                        url = route('productions.store')
                        method = 'post'
                    }

                    axios({
                        method: method,
                        url: url,
                        data: formData,
                        onUploadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Changes have been saved')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.saveLoading = false
                                this.$emit('successful-manage-production-save')

                                if (!this.isEdit) {
                                    this.$inertia.visit(route('productions.edit', response.data.data.id))
                                }
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknow error.')
                            }
                        })
                        .catch((error) => {
                            if( error?.response ) {
                                this.$root.snackbar.error(error.response.data.message)
                                this.errors = error.response?.data?.errors
                            } else {
                                console.log(error)
                                this.$root.snackbar.error(error)
                            }
                            this.saveLoading = false
                        })
                } else {
                    this.$root.snackbar.error('Please fill all required fields.')
                }
            },
            async archiveProduction()
            {
                if (await this.$root.confirm.open(`Delete Production`, `You are about to delete ${this.production.name}  #${this.production.id}`)) {

                    let method = 'delete'
                    let url = route('productions.destroy', this.production.id)
                    let payload = this.member

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Production has been deleted')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archiveLoading = false
                                this.$emit('successful-production-delete')

                                this.$inertia.visit(route('productions.index'))
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                            this.archiveLoading = false
                        })
                }
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.production = newInput
            },
            saveLoading(newValue, oldValue) {
                this.$emit('save-loading-change', newValue)
            }
        }
    }
</script>
<style scoped>

.section > .v-input{
    flex-grow: 0;
}

</style>
